<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :product-group="productGroup"
            :all-product-groups="allProductGroups"
            :selected-parent-groups="inertiaSelectedParentGroups"
            :selected-child-groups="inertiaSelectedChildGroups"
            :selected-product-group-brands="selectedProductGroupBrands"
            :brands="brands"
            @form-submitted="submitData"
        />
    </DCard>
</template>
<script>
import Form from '~@/Components/Products/ProductGroups/Form'

export default {
    name: 'ProductGroupUpdate',
    components: {
        Form
    },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productGroup: {
            type: Object,
            default: () => { return {} }
        },
        allProductGroups: {
            type: Array,
            default () {
                return []
            }
        },
        inertiaSelectedParentGroups: {
            type: Array,
            default () {
                return []
            }
        },
        inertiaSelectedChildGroups: {
            type: Array,
            default () {
                return []
            }
        },
        brands: {
            type: Array,
            default () {
                return []
            }
        },
        selectedProductGroupBrands: {
            type: Array,
            default () {
                return []
            }
        }
    },
    methods: {
        submitData (form) {
            form.put(this.$route('products.product-groups.update', this.productGroup.id))
        },
        updateSelectedParentGroups (values) {
            this.form.form_selected_parent_groups = values
        },
        updateSelectedChildGroups (values) {
            this.form.form_selected_child_groups = values
        }
    }
}
</script>
